<div class="title-container">
  <span class="title">{{model.title$() | translate}}</span>
</div>
